import { create } from 'zustand';
import { jwtDecode } from 'jwt-decode';
import { getToken } from '@/utils/services/security';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

const useUserStore = create(
	devtools(
		persist(
			(set) => ({
				id: null,
				acciones: null,
				nombre: null,
				token: '',
				entidadSeleccionada: {
					id: null,
					identificador: null,
					nombre: null,
					permisos: null,
					sucursal: null,			
					nivelAprobacion: null,
				},
				setDatosUser: (datosUser) =>
					set({
						id: datosUser.id,
						acciones: JSON.parse(datosUser.acciones),
						nombre: datosUser.nombre,
						entidadSeleccionada: datosUser.entidadSeleccionada
					}),
				setToken: (token) => set({ token: token }),
				setEntidadSeleccionada: (entidadSeleccionada) =>
					set({ entidadSeleccionada: entidadSeleccionada }),

				// User: () => {
				//   const token = getToken();
				//   const decoded = jwtDecode(token);
				//   set({ id: decoded.acciones, nombre: decoded.nombre });
				// },
			}),
			{
				name: 'data-User',
				storage: createJSONStorage(() => localStorage),
			}
		)
	)
);

export default useUserStore;
